import React, { useEffect } from 'react';
import { useStore } from '../../../../../../../stores/root';
import styles from './styles.module.scss';

// assets

// services

// props

// components
import { Checkbox, Stack, TextField } from '@fluentui/react';
import Text from '../../../../../../typography/text';
import Label from '../../../../../../typography/label';
import { TSelectedFilterKey } from '.';
import { IOutcomeResourceShorterProps } from '../../../../../../../props/finance/outcomes';
import ISubsidiariesResourceShort from '../../../../../../../props/data/subsidiaries';

type OutcomeInvoicesSummaryFilterSubsidiaryProps = {
    invoices: IOutcomeResourceShorterProps[];
    hideSearch?: boolean;
    onChange(key: TSelectedFilterKey, selected: ISubsidiariesResourceShort[]): void;
}

const OutcomeInvoicesSummaryFilterSubsidiary: React.FC<OutcomeInvoicesSummaryFilterSubsidiaryProps> = (props: OutcomeInvoicesSummaryFilterSubsidiaryProps) => {
    const { banner } = useStore();
    const [keyword, setKeyword] = React.useState<string>("");
    const [selected, setSelected] = React.useState<ISubsidiariesResourceShort[]>([]);

    useEffect(() => {

    }, [props.invoices]);

    const getUniqueSubsidiaries = (): ISubsidiariesResourceShort[] => {
        const subsidiaries: ISubsidiariesResourceShort[] = [];

        props.invoices.forEach((invoice) => {
            const exist = subsidiaries.find((s) => s.id === invoice.subsidiary?.id);
            if (!exist && invoice.subsidiary) {
                subsidiaries.push(invoice.subsidiary);
            }
        });

        return subsidiaries;
    }

    const renderOption = (subsidiary: ISubsidiariesResourceShort) => {
        const isChecked = selected.findIndex((s) => s.id === subsidiary.id) > -1;

        return <Checkbox onChange={(ev, checked) => onChange(!checked, subsidiary)} checked={isChecked} onRenderLabel={() => {
            return <Stack styles={{root: {marginTop: 3, marginLeft: 5}}}>
                <Text size={'small'}>{subsidiary.name}</Text>
            </Stack>
        }} />
    }

    const onChange = (checked: boolean | undefined, subsidiary: ISubsidiariesResourceShort) => {
        let _selected = selected;
        if (checked) {
            _selected = _selected.filter((s) => s.id !== subsidiary.id);
        } else {
            _selected.push(subsidiary);
        }

        setSelected([..._selected]);
        props.onChange('subsidiary', _selected);
    }

    return <Stack className={styles.container} tokens={{childrenGap: 10}}>
        <Label size={"small"}>Subdiairies</Label>
        {props.hideSearch ? null : <TextField iconProps={{iconName: "Search"}}
            placeholder={'Search subsidiary ...'}
            value={keyword}
            onChange={(ev, value) => setKeyword(value || "")} />}
        <Stack className={styles.options} tokens={{childrenGap: 8}}>
            {getUniqueSubsidiaries().filter((s) => s.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1).map((sub) => {
                return renderOption(sub);
            })}
        </Stack>
    </Stack>;
};

export default OutcomeInvoicesSummaryFilterSubsidiary;
